import { Container, Grid, Toolbar } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { TopBarSectionVisibilityType } from '../../types'
import { DesktopLangAndUser } from './desktop-lang-and-user'
import { DesktopLinks, DesktopLinksProps } from './desktop-links'
import { TopBarLogo } from '../top-bar-logo'

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1
  },
  sectionDesktop: {
    borderBottom: `0.7rem solid ${theme.variables.colors.sectionDesktop.borderBottom}`,
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex'
    }
  }
}))

type DesktopToolBarProps = TopBarSectionVisibilityType & DesktopLinksProps

export const DesktopToolBar = ({
  showLangAndUser,
  showNavigationLinks,
  showUserName,
  useAdminTool
}: DesktopToolBarProps) => {
  const classes = useStyles()

  return (
    <Container className={classes.sectionDesktop}>
      <Toolbar className={classes.grow} disableGutters>
        <Grid alignItems="center" container justifyContent="space-between">
          <Grid item>
            <TopBarLogo />
          </Grid>
          <Grid item>
            {showNavigationLinks && (
              <DesktopLinks useAdminTool={useAdminTool} />
            )}
          </Grid>
          <Grid item>
            {showLangAndUser && (
              <DesktopLangAndUser showUserName={showUserName} />
            )}
          </Grid>
        </Grid>
      </Toolbar>
    </Container>
  )
}
